import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { useState } from "react";
import { theme } from "styles/theme";
import Button from "uis/Button";
import Icon from "uis/Icon";
import InputField from "uis/InputField";
import UI from "@mile-meeting/mile-ui";
import {
  Annotation,
  DropdownContainer,
  DropdownIcon,
  DropdownLabel,
  MessageContainer,
  SubContainer,
  TabBtn,
  TabContainer,
  Title,
} from "./uis";
import { TKakaoAlimContent } from "apis/visitors/setting/kakao-alimtalk";

const SectionContainer = styled.div<{ open?: boolean }>`
  flex-direction: column;
  gap: 14px;
  display: ${(props) => (props.open ? "flex" : "none")};
  padding: 40px 24px;
  border-bottom: 1px solid ${theme.neutral50};
`;

const ContentContainer = styled.div`
  border-radius: 10px;
  background-color: ${theme.neutral50};
  padding: 24px;
  width: 400px;
  min-height: 200px;
`;

export const stringToHtml = (str: string) => {
  return <div dangerouslySetInnerHTML={{ __html: str }} />;
};

export const ViewVisitGuide = ({ data }: { data: TKakaoAlimContent }) => {
  const [isOpenAddress, setIsOpenAddress] = useState<boolean>(true);
  const [isOpenMessage, setIsOpenMessage] = useState<boolean>(true);
  const [page, setPage] = useState<string>("한국어");
  return (
    <SubContainer>
      <Annotation>
        * 방문 일정 예약시, 방문자에게 카카오톡 알림톡으로 전송되는 방문 일정 안내 페이지에 표시되는 정보입니다.
      </Annotation>
      <DropdownContainer onClick={() => setIsOpenAddress(!isOpenAddress)}>
        <DropdownLabel>주소 설정</DropdownLabel>
        <DropdownIcon open={isOpenAddress}>
          <Icon name="top-arrow" />
        </DropdownIcon>
      </DropdownContainer>
      <SectionContainer open={isOpenAddress}>
        <InputField
          placeholder={data.addressForMap}
          type="disabled"
          styles={{
            container: css`
              width: 400px;
            `,
          }}
        />
        <InputField
          placeholder={data.address.split(data.addressForMap)[1]}
          type="disabled"
          styles={{
            container: css`
              width: 400px;
            `,
          }}
        />
      </SectionContainer>

      <DropdownContainer onClick={() => setIsOpenMessage(!isOpenMessage)}>
        <DropdownLabel>안내 메세지</DropdownLabel>
        <DropdownIcon open={isOpenMessage}>
          <Icon name="top-arrow" />
        </DropdownIcon>
      </DropdownContainer>
      {isOpenMessage && (
        <>
          <TabContainer>
            {["한국어", "영어"].map((item, index) => (
              <TabBtn key={index} onClick={() => setPage(item)} isPressed={item === page}>
                {item}
              </TabBtn>
            ))}
          </TabContainer>
          <MessageContainer>
            <Title>추가 안내사항</Title>
            {page === "한국어" && (
              <ContentContainer>{stringToHtml(data.additionalInfosHtmlInKoreanFormat)}</ContentContainer>
            )}
            {page === "영어" && (
              <ContentContainer>{stringToHtml(data.additionalInfosHtmlInEnglishFormat)}</ContentContainer>
            )}
          </MessageContainer>
          <MessageContainer>
            <Title>오시는길 상세 설명</Title>
            {page === "한국어" && (
              <ContentContainer>{stringToHtml(data.directionsHtmlInKoreanFormat)}</ContentContainer>
            )}
            {page === "영어" && <ContentContainer>{stringToHtml(data.directionsHtmlInEnglishFormat)}</ContentContainer>}
          </MessageContainer>
        </>
      )}
    </SubContainer>
  );
};

export default ViewVisitGuide;
